import { createActions } from "../../helpers/utils/createActions";
import { DOCUMENT_CENTER } from "./actionTypes";

export const getListaDocumentCenter = createActions(DOCUMENT_CENTER.GET_LIST);
export const getDocumentCenterProducts = createActions(DOCUMENT_CENTER.GET_DOCUMENT_CENTER_PRODUCTS);
export const getDownloadDocumentCenter = createActions(DOCUMENT_CENTER.GET_DOWNLOAD_DOCUMENT_CENTER);

export const loadEmptyDocumentCenter = (payload) => ({ type: DOCUMENT_CENTER.LOAD_EMPTY, payload });
export const cleanMessageDocumentCenter = (payload) => ({ type: DOCUMENT_CENTER.CLEAN_MESSAGE, payload });
export const changePageSizeDocumentCenter = (payload) => ({ type: DOCUMENT_CENTER.CHANGE_PAGE_SIZE_DOCUMENT_CENTER, payload });